import { QuestDefinition } from './types';

/**
 * Quest definition for the WallSketch Editor tool (WallSketchEditorTool / 'wall_sketch_editor').
 *
 * The default hint nudges the user toward interaction; once they enter edit
 * mode (by clicking a node or wall), the hint switches to the keyboard cheat
 * sheet for committing or cancelling.
 */
export const wallSketchEditorQuest: QuestDefinition = {
  toolName: 'wall_sketch_editor',
  states: {
    editing: 'editing — drag to move · right-drag to extrude · Delete to remove · Enter to save · Esc to cancel · Shift = nodes only · Ctrl = no snap',
  },
  defaultKey: 'click a node or wall to start editing',
};
